// extracted by mini-css-extract-plugin
export var pageHeader = "PageHeader-module--page-header--KyQsj";
export var fullHeight = "PageHeader-module--full-height--x4h8O";
export var lightContent = "PageHeader-module--light-content--S4ONd";
export var titleWrapper = "PageHeader-module--title-wrapper--1jZcX";
export var title = "PageHeader-module--title--t7lV4";
export var subtitle = "PageHeader-module--subtitle--1Sexd";
export var overline = "PageHeader-module--overline--uLd8G";
export var backgroundImageWrapper = "PageHeader-module--background-image-wrapper--FsoZn";
export var backgroundImage = "PageHeader-module--background-image--PZlRV";